import {Component, ElementRef, OnDestroy, OnInit, ViewChild, ViewEncapsulation} from '@angular/core';
import {AuthService} from '../../services/auth.service';
import {MatTableDataSource} from '@angular/material/table';
import {MatPaginator} from '@angular/material/paginator';
import {MatSort} from '@angular/material/sort';
import {IcDataService} from '../../services/ic-data.service';
import {Subscription} from 'rxjs';
import {fuseAnimations} from '@fuse/animations';
import {MatSnackBar} from '@angular/material/snack-bar';
import { NICEDigitalTag } from 'app/models/NICE_DigitalTag.model';
import {Papa} from "ngx-papaparse";
import {SaveDigitalTagsDialogComponent} from "../../modals/save-digital-tags-dialog/save-digital-tags-dialog.component";
import {MatDialog, MatDialogRef} from "@angular/material/dialog";
import {FormBuilder, FormGroup} from "@angular/forms";


@Component({
    selector: 'digital-tags',
    templateUrl: './digital-tags.component.html',
    animations: fuseAnimations,
    encapsulation: ViewEncapsulation.None
})
export class DigitalTagsComponent implements OnInit, OnDestroy {



    @ViewChild(MatPaginator, {static: true}) paginator: MatPaginator;
    @ViewChild(MatSort, {static: true}) sort: MatSort;
    @ViewChild('dialogContent') selection: any;
    @ViewChild('fileInput') fileInput: ElementRef;

    displayedColumns: string[] = ['title', 'color'];
    filterObj: { searchString: string; showAll: boolean } = {searchString: '', showAll: false};
    filterValue = '';
    private subscriptions: Subscription;
    dataSource: MatTableDataSource<NICEDigitalTag>;
    preValue: any;
    editTagId: any;
    private bulkCreateTagList: NICEDigitalTag[];
    private fileLoadCount= 0;
    saveTagsDialogRef: MatDialogRef<SaveDigitalTagsDialogComponent, any>;
    tagForm: FormGroup;

    constructor(
        public auth: AuthService,
        public icData: IcDataService,
        private _matSnackBar: MatSnackBar,
        private _papaParser: Papa,
        private _matDialog: MatDialog,
        private _formBuilder: FormBuilder
    )
    {
        this.dataSource = new MatTableDataSource();
        this.subscriptions = new Subscription();
    }

    ngOnInit(): void {

        this.tagForm = this._formBuilder.group({
            newTagColor: '',
            newTagTitle: '',
        });
        this.filterValue = this.icData.getDigitalTagFilter();
        this.icData.getDigitalTags()
                .subscribe(
                    {next:
                            (response) => {
                                if (response != null) {
                                    this.dataSource.data = response;
                                }
                            }
                    });
            this.dataSource.filterPredicate = (myObject, filter): boolean => {
                const what2Search = myObject.id.toString() + myObject.title.toLowerCase();
                const filterObj: { searchString: string; showAll: boolean } = JSON.parse(filter);
                return (what2Search.indexOf(filterObj.searchString) > -1);
            };
            this.applyFilter();

            this.dataSource.paginator = this.paginator;
            // this.dataSource.paginator.pageSize = 10;
            this.dataSource.sort = this.sort;
    }


    ngOnDestroy(): void {
        // unsubscribe from all subscriptions when destroying the component
        this.subscriptions.unsubscribe();
    }

    applyFilter(event?: Event): void {
        if (event) {
            this.filterValue = (event.target as HTMLInputElement).value;
            this.icData.putDigitalTagFilter(this.filterValue);
            this.filterObj.searchString = this.filterValue.trim().toLowerCase();
        }else{
            this.filterValue = this.icData.getDigitalTagFilter();
            this.filterObj.searchString = this.filterValue.trim().toLowerCase();
        }
        this.dataSource.filter = JSON.stringify(this.filterObj);
    }

    clearFilter(): void {
        this.filterValue = '';
        this.icData.putDigitalTagFilter(this.filterValue);
        this.applyFilter();
    }

    beginInlineEdit(tag: NICEDigitalTag) {
        this.preValue = JSON.parse(JSON.stringify(tag));
        this.editTagId = tag.id;
    }

    saveInLineEdit(tag) {
        if (tag !== this.preValue) {
            const updateTag = JSON.parse(JSON.stringify(tag));
            this.icData.updateDigitalTag(tag.id,tag.title,tag.color).subscribe(
                (response: any) => {
                    this.editTagId = 0;
                    this._matSnackBar.open('Tag saved', 'OK', {
                        verticalPosition: 'top',
                        duration: 2000
                    });
                },
                (err) => {
                    this.editTagId = 0;
                    this._matSnackBar.open('Error: ' + err, 'OK', {
                        verticalPosition: 'top',
                        panelClass: ['mat-toolbar', 'mat-warn']
                    });
                });
        }
    }

    cancelInLineEdit() {
        this.editTagId = 0;
        this.preValue = null;
    }

    goToDigitalTagsACD() {
            const url = this.auth.apiHelper.acdRedirectURL + this.auth.apiHelper.digitalUIEndpoint + 'settings/tags#/';
            window.open(url, "_blank");
    }

    onFilesSelected(csvSelectEvent: any) {
            this.bulkCreateTagList = [];
            for (const file of csvSelectEvent.target.files) {
            const reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = (): void => {
                const csvTemplateString = atob((reader.result as string).split(',')[1]);
                const papaConfig = {
                    header: true,
                    step: (result): void => {
                        console.log('Step: ', result);
                        if (result.data.Title && result.data.HexColor)
                        {
                            const singleTag = new NICEDigitalTag({title: result.data.Title, color: result.data.HexColor});
                            this.bulkCreateTagList.push(singleTag);
                            this.fileLoadCount = this.fileLoadCount + 1;
                        }
                    },
                    complete: (result): void => {
                        this.processBulkList();
                    },
                    skipEmptyLines: true,
                };
                this._papaParser.parse(csvTemplateString, papaConfig);
            };
            reader.onerror = (error): void => {
                console.log('Error: ', error);
                this.fileInput.nativeElement.value = '';
            };
        }
    }

    private processBulkList() {
        this.saveTagsDialogRef = this._matDialog.open(SaveDigitalTagsDialogComponent, {
            disableClose: true,
            data: {
                records: this.bulkCreateTagList,
            }
        });
        this.saveTagsDialogRef.afterClosed().subscribe((processresult) => {
            this.bulkCreateTagList = [];
            this.ngOnInit();
        });
    }

    addTag() {
        this.icData.createDigitalTag(this.tagForm.get('newTagTitle').value, this.tagForm.get('newTagColor').value).subscribe({
            next: (response) => {
                this._matSnackBar.open('Tag saved', 'OK', {
                    verticalPosition: 'top',
                    duration: 2000
                });
                this.ngOnInit();
                this.tagForm.reset();
            },
            error: (err) => {
                this._matSnackBar.open('Error: ' + err, 'OK', {})
            }
        })
    }
}
